import gql from 'graphql-tag';

export const LED_STRIP_CREATE_M = gql`
  mutation LEDStripCreateMutation ($displayId: UUID!, $input: LedStripInput!) {
    createLedStrip(displayId: $displayId, input:$input) {
      success
      message
      code
    }
  }
`;

export const LED_STRIP_UPDATE_M = gql`
  mutation LEDStripUpdateMutation ($displayId: UUID!, $input: LedStripInput!) {
    updateLedStrip(displayId: $displayId, input:$input) {
      success
      message
      code
    }
  }
`;

export const LED_STRIP_DELETE_M = gql`
  mutation LEDStripDeleteMutation ($displayId: UUID!) {
    deleteLedStrip(displayId: $displayId) {
      success
      message
      id
    }
  }
`;

